export enum Theme {
  light = 'light',
  dark = 'dark'
}

export const LIGHT_TEXT_PRIMARY = '#060926';
export const DARK_TEXT_PRIMARY = '#e9ebfb';

type ThemePalette = Record<string, string>;

const darkPalette: ThemePalette = {
  '--color-background': '#2c2c2c',
  '--color-text-primary': DARK_TEXT_PRIMARY,
  '--color-text-secondary': '#b3b3b3',
  '--color-stroke': '#444444',
  '--color-fill': '#b3b3b3',
  '--color-error-primary': '#d2362a',
  '--color-error-secondary': '#912018',
  '--color-error-focus': '#912018',
  '--color-error-accent': '#D2362A',
  '--color-shadow': 'rgba(0, 0, 0, 0.25)',
  '--color-shadow-light': 'rgba(0, 0, 0, 0.15)'
};

export { darkPalette };
